import Component from 'vue-class-component'
import ContainerVue from './Container'
import { IContainerData } from '../../store/editor/components/state'
import { SOUTH } from './Droppable'
import InteractableComponent from './InteractableComponent'
import { Actions } from '../../store/editor/components/helpers'
import HeaderSectionVue from './HeaderSection.vue'
import initializeFactory from './ComponentVueFactoryInitializer'

@Component({
  components: {
    'header-section': HeaderSectionVue
  }
})
export default class ArticleVue extends ContainerVue<IContainerData> {
  private interactable: InteractableComponent

  created(): void {
    initializeFactory()
  }

  mounted() {
    this.interactable = new InteractableComponent(this.$el, this.$store)
    this.interactable.droppable({
      directions: [SOUTH]
    })
      .onDropTo((event) => {
        const destination = this.lastChild
        if (destination) {
          Actions.move(this.$store, {
            destination,
            component: event.dropping,
            direction: event.direction
          })
        }
      })
  }

  destroyed() {
    this.interactable.destroy()
  }
}
